import type { KeyboardEvent } from "react";
import { ROVING_NEXT_KEYS, ROVING_PREVIOUS_KEYS } from "./constants";

/** Marks a chip as part of a roving-focus group; the group element carries `data-roving-group`. */
export const ROVING_ITEM_ATTRIBUTE = "data-roving";
export const ROVING_GROUP_ATTRIBUTE = "data-roving-group";

const ITEM_SELECTOR = `button[${ROVING_ITEM_ATTRIBUTE}]:not(:disabled)`;
const GROUP_SELECTOR = `[${ROVING_GROUP_ATTRIBUTE}]`;

/**
 * Arrow / Home / End move focus between the chips of a group (one tab stop per group; the chip
 * keeps `tabIndex=0`). Selection stays on Enter / Space, so a screen reader can browse safely.
 */
export function moveRovingFocus(event: KeyboardEvent<HTMLButtonElement>): void {
  const { key } = event;
  const forward = ROVING_NEXT_KEYS.has(key);
  const backward = ROVING_PREVIOUS_KEYS.has(key);
  if (!forward && !backward && key !== "Home" && key !== "End") return;
  const items = Array.from(event.currentTarget.closest(GROUP_SELECTOR)?.querySelectorAll<HTMLButtonElement>(ITEM_SELECTOR) ?? []);
  const current = items.indexOf(event.currentTarget);
  if (current === -1) return;
  let target = items.length - 1;
  if (key === "Home") target = 0;
  else if (forward) target = (current + 1) % items.length;
  else if (backward) target = (current - 1 + items.length) % items.length;
  event.preventDefault();
  items[target]?.focus();
}
